import get from 'lodash/get';

const denounceProspectStatus = {
    in_progress: 'En cours',
    standby: 'En veille',
    archived: 'Archivé',
};

function formatDenounceProspectStatus(value: string) {
    return get(denounceProspectStatus, value, value);
}

export { denounceProspectStatus, formatDenounceProspectStatus };
